export default class WmsLayerRefreshController {
    constructor({ refreshInterval = 1000 * 60 } = {}){
        this.refreshInterval = refreshInterval;
        this.refresh = this.refresh.bind(this);
    }

    layerConfig(layerConfig){
        return layerConfig;
    }

    init(map, o, layer, layerConfig, context){
        this.o = o;
        this.layer = layer || (layer && layer.getInternalLayer && layer.getInternalLayer());

        this.interval = setInterval(this.refresh, this.refreshInterval);
    }

    options(o){
        return o;
    }

    update(map, o){
        console.debug('WmsLayerRefreshController update()', { map, o });
        this.o = o;
    }

    remove(map){
        this.layer = null;
        clearInterval(this.interval);
    }

    refresh() {
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless noRedraw was set to true).
        this.layer.setParams({
            timestamp: Date.now()
        }, false);
    }
}



// WEBPACK FOOTER //
// ./js/map/WmsLayerRefreshController.js